import React from 'react';

const IIEC = () => {
  return (
    <div>
      IIEC
      IIEC
    </div>
  );
}

export default IIEC;
